import { createTypes, completeTypes } from 'redux-recompose';
import { retrieveErrors, retrieveSuccessMessage } from '@widergy/web-utils/lib/message';
import { AlertHandler } from '@widergy/energy-ui';

import UserService from 'services/UserService';
import { message } from 'utils/stringUtils';

import { userTurnsSelector } from './selector';

export const actions = createTypes(
  completeTypes(
    ['GET_USER_TURNS', 'CREATE_NEW_TURN', 'UPDATE_TURN', 'CANCELATION_TURN'],
    ['SET_UPDATE_TURN_DATA', 'CLEAN_UPDATE_TURN_DATA']
  ),
  '@@USER'
);

const privateActionCreators = {
  getUserTurnsSuccess: payload => ({
    type: actions.GET_USER_TURNS_SUCCESS,
    target: 'userTurns',
    payload
  }),
  getUserTurnsFailure: error => ({
    type: actions.GET_USER_TURNS_FAILURE,
    target: 'userTurns',
    payload: error
  }),
  createNewTurnSuccess: () => ({
    type: actions.CREATE_NEW_TURN_SUCCESS,
    target: 'createNewTurn'
  }),
  createNewTurnFailure: error => ({
    type: actions.CREATE_NEW_TURN_FAILURE,
    target: 'createNewTurn',
    payload: error
  }),
  updateTurnSuccess: payload => ({
    type: actions.UPDATE_TURN_SUCCESS,
    target: 'updateTurn',
    payload
  }),
  updateTurnFailure: error => ({
    type: actions.UPDATE_TURN_FAILURE,
    target: 'updateTurn',
    payload: error
  }),
  cancelTurnSuccess: payload => ({
    type: actions.CANCELATION_TURN_SUCCESS,
    target: 'cancelTurn',
    payload
  }),
  cancelTurnFailure: error => ({
    type: actions.CANCELATION_TURN_FAILURE,
    target: 'cancelTurn',
    payload: error
  })
};

export const actionCreators = {
  getUserTurns: status => async dispatch => {
    dispatch({ type: actions.GET_USER_TURNS, target: 'userTurns' });
    const response = await UserService.userTurns(status);
    if (response.ok) {
      dispatch(privateActionCreators.getUserTurnsSuccess(userTurnsSelector(response.data)));
    } else {
      const error = retrieveErrors(response.data, message('DefaultMessages:getUserTurnsFailure'));
      dispatch(privateActionCreators.getUserTurnsFailure(error));
    }
  },
  createNewTurn: (slot, form, phone, email, clientNumber) => async dispatch => {
    dispatch({ type: actions.CREATE_NEW_TURN, target: 'createNewTurn' });
    const response = await UserService.createNewTurn(slot, form, phone, email, clientNumber);
    if (response.ok) {
      const messageSuccess = retrieveSuccessMessage(
        response.data,
        message('DefaultMessages:createNewTurnSuccess')
      );
      dispatch(privateActionCreators.createNewTurnSuccess(messageSuccess));
    } else {
      const error = retrieveErrors(response.data, message('DefaultMessages:createNewTurnFailure'));
      AlertHandler.error(error);
      dispatch(privateActionCreators.createNewTurnFailure(error));
    }
  },

  setUpdateTurnData: turnId => dispatch => dispatch({ type: actions.SET_UPDATE_TURN_DATA, payload: turnId }),

  cleanTurnData: () => dispatch => dispatch({ type: actions.CLEAN_UPDATE_TURN_DATA }),

  updateTurn: (turnId, slotId, form, phone, email, clientNumber) => async dispatch => {
    dispatch({ type: actions.UPDATE_TURN, target: 'updateTurn' });
    const response = await UserService.updateTurn(turnId, slotId, form, phone, email, clientNumber);
    if (response.ok) {
      const messageSuccess = retrieveSuccessMessage(
        response.data,
        message('DefaultMessages:updateTurnSuccess')
      );
      dispatch(privateActionCreators.updateTurnSuccess(messageSuccess));
    } else {
      const error = retrieveErrors(response.data, message('DefaultMessages:updateTurnFailure'));
      dispatch(privateActionCreators.updateTurnFailure(error));
      AlertHandler.error(error);
    }
  },

  cancelTurn: turnId => async dispatch => {
    dispatch({ type: actions.CANCELATION_TURN, target: 'cancelTurn' });
    const response = await UserService.cancelTurn(turnId);
    if (response.ok) {
      const messageSuccess = retrieveSuccessMessage(
        response.data,
        message('DefaultMessages:cancelationTurnSuccess')
      );
      dispatch(privateActionCreators.cancelTurnSuccess(messageSuccess));
      AlertHandler.success(messageSuccess);
    } else {
      const error = retrieveErrors(response.data, message('DefaultMessages:cancelationTurnFailure'));
      AlertHandler.error(error);
      dispatch(privateActionCreators.cancelTurnFailure(error));
    }
  }
};

export default actionCreators;
